import ZindexManager from './ZindexManager';
import uniqueId from 'lodash/uniqueId';

const foucusCallbacks = new WeakMap();
function getManagerByName(name, startzindex = 1000) {
    let ch = ZindexManager.managers.get(name);
    if (!ch) {
        ch = new ZindexManager(startzindex, name);
    }
    return ch;
}

function updateIndex(ele, zindex) {
    if (zindex) {
        ele.style.zIndex = zindex;
    } else {
        ele.style.removeProperty('zIndex');
    }
}
export default {
    bind(el, binding) {
        const { channelName } = binding.value || {};
        el.zIndexManager = getManagerByName(channelName);
        el.zIndexUid = uniqueId(`${channelName}_`);
        el.zIndexManager.add(el.zIndexUid);
        el.zIndexManager.indexStore.sub(el.zIndexUid, (newIndex) => {
            updateIndex(el, newIndex);
        });
        foucusCallbacks.set(el, function () {
            el.zIndexManager.shiftElementToStackEnd(el.zIndexUid);
        });
    },
    inserted(el) {
        updateIndex(el, el.zIndexManager.startIndex);
        el.addEventListener('mousedown', foucusCallbacks.get(el));
    },
    unbind(el) {
        el.zIndexManager.remove(el.zIndexUid);
        el.removeEventListener('mousedown', foucusCallbacks.get(el));
    },
};
